import { RootState } from "../Store/Store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { showAuthBannerAction } from "./ShowAuthBannerAction";
import { clearAuthBannerAction } from "./ClearAuthBannerAction";
import { AuthBannerState, AuthBannerStore } from "@model/Authentication.model";

const authBannerSelector = (state: RootState) =>
  state.authBannerReducer as AuthBannerState;

export const AuthBannerStoreImplementation = (): AuthBannerStore => {
  const dispatch = useDispatch();

  const { message, returnPath } = useSelector<RootState, AuthBannerState>(
    authBannerSelector
  );

  const showBanner = useCallback(
    (msg: string, path?: string | null) =>
      showAuthBannerAction(msg, path)(dispatch),
    [dispatch]
  );

  const clearBanner = useCallback(
    () => clearAuthBannerAction()(dispatch),
    [dispatch]
  );

  return {
    bannerMessage: message,
    bannerReturnPath: returnPath,
    showBanner,
    clearBanner,
  };
};
